import { Component, Input, Output, EventEmitter, ViewChild } from "@angular/core";
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { UnitPhoto } from '../../_models/Classes';

@Component({
    selector: 'app-gallery',
    templateUrl: './gallery.component.html',
    styleUrls: ['./gallery.component.scss']
})

export class GalleryComponent {
    @Input() files = [];
    @Output() image = new EventEmitter();
    constructor(protected _domSanitizer: DomSanitizer) { }
    getImage(i: number) {
        this.image.emit({ image: this.files[i], index: i });
    }
    data: SafeUrl;
    public getImageUrl(image) {
        if (image instanceof UnitPhoto) {
            return image.getContentUrl();
        }
        if (!image.data)
            image.data =
                this._domSanitizer.bypassSecurityTrustUrl(window.URL.createObjectURL(image));
        return image.data;
    }
}



// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/shared/gallery/gallery.component.ts